import {useMutation} from '@tanstack/react-query';
import {useCallback} from 'react';
import {storeMutationAdapter} from '../../../../adapter/storeMutationAdapter';

export function useSetSeriesMutationHandler() {
  const {mutateAsync: setSeriesAlarmMutateAsync} = useMutation(
    storeMutationAdapter.setSeriesAlarm()
  );
  const onSetSeriesAlarmMutate = useCallback(
    async (seriesId: number, isAlarmOn: boolean) =>
      await setSeriesAlarmMutateAsync({
        setSeriesAlarmInput: {
          seriesId,
          isAlarmOn,
        },
      }),
    [setSeriesAlarmMutateAsync]
  );

  const {mutateAsync: setSeriesLikeMutateAsync} = useMutation(
    storeMutationAdapter.setSeriesLike()
  );
  const onSetSeriesLikeMutate = useCallback(
    async (seriesId: number, isLike: boolean) =>
      await setSeriesLikeMutateAsync({
        setSeriesLikeInput: {
          seriesId,
          isLike,
        },
      }),
    [setSeriesLikeMutateAsync]
  );

  return {
    onSetSeriesAlarmMutate,
    onSetSeriesLikeMutate,
  };
}
